import { RootState } from 'src/store';

import { ISite } from './types';

export const selectSiteDetails = (state: RootState): ISite | null => state.sites.details;
export const selectSiteLoading = (state: RootState): boolean => state.sites.detailsLoading;
